import { useMemo } from "react";
import { Lock } from "lucide-react";

const OwnerRow = ({ owner, list, onSelect }) => {
  const plates = list.map((s) => s.assigned_plate).filter(Boolean).join(", ");
  return (
    <div data-testid={`owner-row-${owner}`} className="py-3 flex items-start justify-between gap-3">
      <span className="flex items-center gap-2 text-sm text-[#F5F5F5] truncate">
        <Lock className="w-3 h-3 text-[#A3A3A3] shrink-0" />
        <span className="truncate">
          {owner}
          {plates && <span className="text-[#A3A3A3]"> · {plates}</span>}
        </span>
      </span>
      <span className="flex flex-wrap gap-1 justify-end">
        {list.map((s) => (
          <button
            key={s.number}
            data-testid={`owner-space-${s.number}`}
            onClick={() => onSelect(s.number)}
            className="px-2 py-0.5 text-xs font-semibold border border-[#262626] hover:bg-[#1F1F1F] transition-colors rounded-sm"
          >
            {String(s.number).padStart(2, "0")}
          </button>
        ))}
      </span>
    </div>
  );
};

export const OwnerDirectory = ({ spaces, onSelect }) => {
  const owners = useMemo(
    () =>
      Object.entries(
        spaces
          .filter((s) => s.assigned_to)
          .reduce((acc, s) => {
            (acc[s.assigned_to] = acc[s.assigned_to] || []).push(s);
            return acc;
          }, {})
      ).sort((a, b) => a[0].localeCompare(b[0])),
    [spaces]
  );

  return (
    <div className="p-6 border border-[#262626] bg-[#141414] flex flex-col gap-4" data-testid="owner-directory">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold">Permanent Holders</h3>
        <span className="label-tech" data-testid="owner-count">{owners.length}</span>
      </div>
      {owners.length === 0 && <p className="text-sm text-[#A3A3A3]">No permanent assignments yet.</p>}
      <div className="flex flex-col divide-y divide-[#262626]">
        {owners.map(([owner, list]) => (
          <OwnerRow key={owner} owner={owner} list={list} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
};
